<template>
  <div class="app-main-content finance-export">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" :lazy="true" type="card" style="width:100%;">
        <el-tab-pane v-if="tabAccrueReportMonthlyIsShowed" :label="'Accrue Report (Monthly)'" name="accrueReportMonthly">
          <tab-accrue-report-monthly ref="accrueReportMonthly" :copy-month-list="copyMonthList" :latest-monthly-date="latestMonthlyDate" :is-show="accrueReportMonthlyIsShow" :query-branch-list="queryBranchList" :query-dept-id-list="queryDeptIdList" />
        </el-tab-pane>
        <el-tab-pane v-if="tabAccrueReportWeeklyIsShowed" :label="'Accrue Report (Weekly)'" name="accrueReportWeekly">
          <tab-accrue-report-weekly ref="accrueReportWeekly" :copy-date-list="copyDateList" :latest-weekly-date="latestWeeklyDate" :is-show="accrueReportWeeklyIsShow" :query-branch-list="weekBranchList" :query-dept-id-list="weekDeptIdList" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import tabAccrueReportMonthly from './tabAccrueReportMonthly'
import tabAccrueReportWeekly from './tabAccrueReportWeekly'
import { getLoading } from '@/utils/utilBaseElement'
import { loadSearchConditions } from '@/api/clearing/pillReport'
import { cacheKeys, getCacheListByKey, getFilterCacheList } from '@/utils/basicDataCache'

export default {
  name: 'FinanceExport',
  components: { tabAccrueReportMonthly, tabAccrueReportWeekly },
  props: {},
  data() {
    return {
      loading: false,
      activeTabName: 'accrueReportMonthly',
      tabAccrueReportMonthlyIsShowed: this.$checkPermission(['tab_FinanceExport_accrueMonthly']),
      tabAccrueReportWeeklyIsShowed: this.$checkPermission(['tab_FinanceExport_accrueWeekly']),
      accrueReportMonthlyIsShowed: false,
      accrueReportWeeklyIsShowed: false,
      copyMonthList: [], // copy Month列表
      latestMonthlyDate: null, // 最新月度数据生成时间
      copyDateList: [], // copy Date列表
      latestWeeklyDate: null, // 最新月中数据生成时间
      queryBranchList: [], // 查询权限分公司
      queryDeptIdList: [], // 查询权限部门ID
      weekBranchList: [], // 查询权限分公司
      weekDeptIdList: [] // 查询权限部门ID
    }
  },
  computed: {
    accrueReportMonthlyIsShow() {
      if (this.activeTabName === 'accrueReportMonthly' && !this.accrueReportMonthlyIsShowed) {
        this.accrueReportMonthlyIsShowed = true
      }
      return this.accrueReportMonthlyIsShowed
    },
    accrueReportWeeklyIsShow() {
      if (this.activeTabName === 'accrueReportWeekly' && !this.accrueReportWeeklyIsShowed) {
        this.accrueReportWeeklyIsShowed = true
      }
      return this.accrueReportWeeklyIsShowed
    }
  },
  created() {
    this.defaultActiveTabName()
    this.loadInitData()
  },
  methods: {
    defaultActiveTabName() {
      if (this.tabAccrueReportMonthlyIsShowed) {
        this.activeTabName = 'accrueReportMonthly'
      } else if (this.tabAccrueReportWeeklyIsShowed) {
        this.activeTabName = 'accrueReportWeekly'
      }
    },
    loadInitData() {
      this.loading = getLoading()
      loadSearchConditions({ 'hrMark': false }).then(res => {
        if (res.data) {
          this.copyMonthList = res.data.copyMonthList
          this.latestMonthlyDate = res.data.latestMonthlyDate
          this.copyDateList = res.data.copyDateList
          this.latestWeeklyDate = res.data.latestWeeklyDate
          // Monthly
          const branchIds = res.data.branchIds || []
          if (branchIds.length === 0) {
            this.queryBranchList = getCacheListByKey(cacheKeys.basic_data_Office_All)
          } else {
            const currentList = getFilterCacheList(cacheKeys.basic_data_Office_All, (item) => {
              return branchIds.includes(item.officeId)
            }) || []
            if (currentList.length !== 0) {
              this.queryBranchList.push(...currentList)
            }
          }
          this.queryDeptIdList = res.data.deptIds
          // Weekly
          const weekBranchIds = res.data.weekBranchIds || []
          if (weekBranchIds.length === 0) {
            this.weekBranchList = getCacheListByKey(cacheKeys.basic_data_Office_All)
          } else {
            const currentList = getFilterCacheList(cacheKeys.basic_data_Office_All, (item) => {
              return weekBranchIds.includes(item.officeId)
            }) || []
            if (currentList.length !== 0) {
              this.weekBranchList.push(...currentList)
            }
          }
          this.weekDeptIdList = res.data.weekDeptIds
          this.$nextTick(() => {
            this.$refs.accrueReportMonthly.setDefaultCondition()
            this.$refs.accrueReportWeekly.setDefaultCondition()
          })
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">

</style>
